import config from '../config';
export const debug = (message, ...optionalParams) => {
    if (!isProductionLikeEnvironment()) {
        console.log(message, optionalParams);
    }
};
export const isProductionLikeEnvironment = () => {
    return process.env.NODE_ENV === 'production' &&
        ['production', 'staging'].includes(config.checkitEnv);
};
//# sourceMappingURL=environment-utils.js.map